import * as React from "react";
const SvgMinusXsmallBold = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" viewBox="0 0 12 12" {...props}><path fill="currentColor" d="M9.5 5.375a.625.625 0 1 1 0 1.25h-7a.625.625 0 1 1 0-1.25z" /></svg>;
export default SvgMinusXsmallBold;